import React, {Component} from 'react'

import Threesome from '../../../assets/triangolo.png'

const TextUser = (props) => <div className={props.bold ? "text-bold-user" : "text-regular-user"}>{props.children}</div>

export default class UserInfoBox extends Component {


    render() {
        return (
                <div className="col-md-4 col-md-offset-1 col-information-user hidden-xs hidden-sm">
                    <div className="information-container">
                        <div style={{marginLeft: 30}}>
                            <div style={{marginTop: 15, marginBottom: 10}}>
                                <TextUser bold>TITOLETTO</TextUser>
                                <TextUser>
                                    FINTO TESTO BREVE O LUNGO CHE<br/>
                                    AIUTA L'UTENTE, SPIEGA IL PIANO<br/>
                                    E LE OPERAZIONI NECESSARIE<br/>
                                    PASSO PASSO.
                                </TextUser>
                            </div>
                            <span className="threesom-span">
                            <img src={Threesome}/>
                            </span>
                            <div style={{marginBottom: 10}}>
                                <TextUser bold>TITOLETTO</TextUser>
                                <TextUser>
                                    FINTO TESTO BREVE O LUNGO CHE<br/>
                                    AIUTA L'UTENTE, SPIEGA IL PIANO<br/>
                                    E LE OPERAZIONI NECESSARIE<br/>
                                    PASSO PASSO.
                                </TextUser>
                            </div>
                            <div>
                                <TextUser bold>TITOLETTO</TextUser>
                                <TextUser>
                                    FINTO TESTO BREVE O LUNGO CHE<br/>
                                    AIUTA L'UTENTE, SPIEGA IL PIANO<br/>
                                    E LE OPERAZIONI NECESSARIE<br/>
                                    PASSO PASSO.
                                </TextUser>
                            </div>
                        </div>
                    </div>
            </div>);
        }
    }


// WEBPACK FOOTER //
// ./src/containers/UserArea/UserInfoBox/UserInfoBox.js